export const BUTTON_SIZE_BREAKPOINT = 1600;
export const DEFAULT_MAX_COUNT = 6;
export const LARGE_BUTTON_WIDTH = 56;
export const LARGE_BUTTON_CIRCLE_WIDTH = 40;
export const MEDIUM_BUTTON_WIDTH = 42;
export const MEDIUM_BUTTON_CIRCLE_WIDTH = 32;
export const BUTTON_MARGIN = 8;
export const SCROLLBAR_WIDTH = 20;